import { FunctionComponent } from 'react';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.scss';

export type PaginationProps = {
  pageCount: number;
  forcePageNumber?: number;
  handlePageClick: ({ selected }: { [idx: string]: number }) => void;
};

type FC = FunctionComponent<PaginationProps>;

const Pagination: FC = ({ pageCount, forcePageNumber, handlePageClick }: PaginationProps) => (
  <div data-testid="pagination">
    <ReactPaginate
      previousLabel="«"
      nextLabel="»"
      pageCount={pageCount}
      forcePage={forcePageNumber}
      onPageChange={handlePageClick}
      containerClassName={styles.paginationContainer}
      disabledClassName={styles.disabledLink}
      activeClassName={styles.activeLink}
    />
  </div>
);

export default Pagination;
